import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment-timezone';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/ar';
import 'moment/locale/zh-cn';
import en from '../locales/en.yml';
import es from '../locales/es.yml';
import fr from '../locales/fr.yml';
import ar from '../locales/ar.yml';
import zh from '../locales/zh.yml';
import { SUPPORTED_LOCALE_CODES, DEFAULT_LOCALE } from './supportedLocales';

const MOMENT_LOCALE_MAP = { en: 'en', es: 'es', fr: 'fr', ar: 'ar', zh: 'zh-cn' };

// localStorage key used to persist the active dashboard locale and to
// notify other tabs (via the `storage` event) when the user picks a new one.
export const LOCALE_STORAGE_KEY = 'dashboardLocale';

const safeStorage = {
  get() {
    try { return window.localStorage.getItem(LOCALE_STORAGE_KEY); }
    catch (_e) { return null; }
  },
  set(value) {
    try { window.localStorage.setItem(LOCALE_STORAGE_KEY, value); }
    catch (_e) { /* localStorage unavailable (private mode, quota, etc.) */ }
  },
};

const initialLocale = SUPPORTED_LOCALE_CODES.includes(safeStorage.get())
  ? safeStorage.get()
  : DEFAULT_LOCALE;

i18n
  .use(initReactI18next)
  .init({
    lng: initialLocale,
    fallbackLng: DEFAULT_LOCALE,
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      ar: { translation: ar },
      zh: { translation: zh },
    },
    interpolation: { escapeValue: false },
  });

moment.locale(MOMENT_LOCALE_MAP[initialLocale] || 'en');

i18n.on('languageChanged', (lng) => {
  moment.locale(MOMENT_LOCALE_MAP[lng] || 'en');
});

// Cross-tab sync: when another tab persists a new locale, mirror it here.
if (typeof window !== 'undefined' && window.addEventListener) {
  window.addEventListener('storage', (event) => {
    if (event.key !== LOCALE_STORAGE_KEY) return;
    const next = event.newValue;
    if (!next || next === i18n.language) return;
    if (!SUPPORTED_LOCALE_CODES.includes(next)) return;
    i18n.changeLanguage(next);
  });
}

export const persistLocale = (locale) => safeStorage.set(locale);

export default i18n;
